import React from 'react';
import { AdvantagesSection } from '../components/AdvantagesSection';
import { BonusesSection } from '../components/BonusesSection';
import { CountdownSection } from '../components/CountdownSection';
import { FaqSection } from '../components/FaqSection';
import { FinalCtaSection } from '../components/FinalCtaSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { Hero } from '../components/Hero';
import { OfferSection } from '../components/OfferSection';
import { ProblemSection } from '../components/ProblemSection';
import { SiteFooter } from '../components/SiteFooter';
import { StandardsSection } from '../components/StandardsSection';
import { StickyCta } from '../components/StickyCta';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { VolumesSection } from '../components/VolumesSection';
export function Landing() {
  return <div className="w-full bg-steel-950 font-sans text-ink-200" data-id="element-234" data-mp="m7288f05t98n">
      <Hero data-id="element-235" data-mp="m58ygqu928wf" />
      <main data-id="element-236" data-mp="2a0ig2bxce55">
        <ProblemSection data-id="element-237" data-mp="2ajskwvc1y8m" />
        <StandardsSection data-id="element-238" data-mp="2atjqns46bfw" />
        <VolumesSection data-id="element-239" data-mp="2bbm825ddlw9" />
        <BonusesSection data-id="element-240" data-mp="3tgbgrqpjv0ss" />
        <AdvantagesSection data-id="element-241" data-mp="3tg1zqsmhg3z8" />
        <CountdownSection data-id="element-242" data-mp="3tes03yzzenqh" />
        <OfferSection data-id="element-243" data-mp="3tio8gvl40pj1" />
        <GuaranteeSection data-id="element-244" data-mp="3pegeaivvuhdf" />
        <TestimonialsSection data-id="element-245" data-mp="3pfriukx5jt5l" />
        <FaqSection data-id="element-246" data-mp="3pezw7zlj95rg" />
        <FinalCtaSection data-id="element-247" data-mp="3kfn1ksof6ueb" />
      </main>
      <SiteFooter data-id="element-248" data-mp="3kgopvyug5ddz" />
      <StickyCta data-id="element-249" data-mp="3kh7vcg2wu9b4" />
    </div>;
}